import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { TradeReviewReportData } from "../types";

export const useTradeReviewReportData = () => {
  const data = useSelector<StoreType, TradeReviewReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.tradeReview.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
